const externalFactors = ['www', 'http', '//', 'tel:', 'mailto:'];

export const isExternal = url => {
  return !!externalFactors.find(factor => url.includes(factor));
};
